import { Button, Divider, Grid, Header, Icon, Label } from "semantic-ui-react";
import { get, isEmpty } from "lodash";
import AppLink from "../Common/AppLink";
import React from "react";
import { ConfirmationModal } from "../Common/ConfirmationModal";
import { Link } from "react-router-dom";

export const UserList = ({ users, onDelete, currentUser }) => {
  return (
    <Grid padded>
      <Grid.Row verticalAlign="middle" columns={3}>
        <Grid.Column textAlign="left" width={2}>
          <h3>USERS</h3>
        </Grid.Column>
        <Grid.Column>
          <Label size="large" circular color="black">
            {get(users, "length", 0)}
          </Label>
        </Grid.Column>
        <Grid.Column width={5} />
        <Grid.Column width={3} textAlign="right">
          <AppLink to="/users/new" icon="add" background content="New User" />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={7}>
        <Grid.Column width={1} as={Header} size="small" textAlign="left">
          Id
        </Grid.Column>
        <Grid.Column width={3} as={Header} size="small" textAlign="left">
          Email
        </Grid.Column>
        <Grid.Column width={2} as={Header} size="small" textAlign="left">
          Admin
        </Grid.Column>
        <Grid.Column width={2} as={Header} size="small" textAlign="left">
          First Name
        </Grid.Column>
        <Grid.Column width={2} as={Header} size="small" textAlign="left">
          Last Name
        </Grid.Column>
        <Grid.Column width={2} as={Header} size="small" textAlign="left">
          Tenants
        </Grid.Column>
        <Grid.Column width={2} as={Header} size="small" textAlign="left">
          Actions
        </Grid.Column>
      </Grid.Row>
      <Divider />
      {!isEmpty(users) &&
        users.map(
          (user, index) =>
            user && <UserRow onDelete={onDelete} currentUser={currentUser} row={index} user={user} key={index} />
        )}

      {isEmpty(users) && (
        <Grid.Row textAlign="center">
          <Grid.Column>No users</Grid.Column>
        </Grid.Row>
      )}
    </Grid>
  );
};

const modalConfig = {
  cancel: { text: "Cancel", color: "orange" },
  confirm: { text: "Confirm Delete", className: "confirmButton" }
};
const UserRow = ({ row, user, onDelete, currentUser }) => (
  <Grid.Row data-test={`users-tr-${row}`} columns={7}>
    <Grid.Column className="break-word" data-test="item" width={1} textAlign="left">
      {user.id}
    </Grid.Column>
    <Grid.Column className="break-word" data-test="item" width={3} textAlign="left">
      {user.email}
    </Grid.Column>
    <Grid.Column className="break-word" data-test="item" width={2} textAlign="left">
      {user.admin ? "Yes" : "No"}
    </Grid.Column>
    <Grid.Column className="break-word" data-test="item" width={2} textAlign="left">
      {user.firstName}
    </Grid.Column>
    <Grid.Column className="break-word" data-test="item" width={2} textAlign="left">
      {user.lastName}
    </Grid.Column>
    <Grid.Column className="break-word" data-test="item" width={2} textAlign="left">
      {user.admin ? <span className="all-tenants">All tenants</span> : get(user, "tenant.name", "")}
    </Grid.Column>
    <Grid.Column width={4} textAlign="right">
      <Grid>
        <Grid.Row columns={2}>
          <Link to={`/users/${user.id}/edit`}>
            <Button as="label" className="text orange transparent-background">
              <Icon name="edit" />
              Edit
            </Button>
          </Link>
          {currentUser.email !== user.email && (
            <ConfirmationModal
              header={"Delete User " + user.firstName + " " + user.lastName}
              config={modalConfig}
              content={"This operation cannot be undone. Please confirm you want to delete user."}
              onOkClicked={() => onDelete(user.id)}
              trigger={
                <Button className="text orange transparent-background" size="medium" color="orange" type="submit">
                  <Icon name="trash alternate outline" /> Delete
                </Button>
              }
            />
          )}
        </Grid.Row>
      </Grid>
    </Grid.Column>
  </Grid.Row>
);

export default UserList;
